import styled, { css } from 'styled-components';
import { srOnly } from '@/app/components/search/styles/mixins.ts';

type RankingBoxContainerProps = {
  hasPreselectedFlight?: boolean;
  variant?: 'default' | 'evolution';
};

export const RankingBoxContainer = styled.div<RankingBoxContainerProps>`
  width: 100%;
  line-height: 20px;
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  position: relative;

  ${({ hasPreselectedFlight }) =>
    hasPreselectedFlight &&
    css`
      margin-top: 0;
      margin-bottom: 20px;
    `}

  ${({ variant }) =>
    variant === 'evolution' &&
    css`
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      white-space: initial;
    `}

  a {
    text-decoration: underline;
  }

  img {
    display: inline;
    vertical-align: middle;
    margin-left: 2px;
  }
`;

/** "Opens in a new tab", read as the ranking link's description and never shown (MPH-1471). */
export const NewTabDescription = styled.span`
  ${srOnly};
`;
